import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createSmtpCredential } from '../../helpers/api_helper';

const useCreateSmtpCredential = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const createSmtpCredentialHook = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createSmtpCredential(tenantId, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create SMTP credential: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createSmtpCredential: createSmtpCredentialHook, loading, error };
};

export default useCreateSmtpCredential;